import * as React from "react";
import { IChannelItemProps } from "./~types/ChannelItemProps";
import { IChannelItemReduxProps } from "./~types/ChannelItemReduxProps";
import {
  channelTypeToString,
  ChannelType,
} from "src/app/channel/~store/models/enums/ChannelType";
import { Button, Input, Tooltip, Label } from "reactstrap";
import copy from "copy-to-clipboard";
import getScript from "../../../../shared/helpers/script-helper/ScriptHelper";

import "./ChannelItem.css";
import { IChannelItemState } from "./~types/ChannelItemState";
import { IChannel } from "src/app/channel/~store/models/Channel";
import { showErrorToastr } from "src/app/shared/helpers/toastr-helper/ToastrHelper";
import ChannelOperatorList from "./channel-operator-list/ChannelOperatorList";
import { ModalWindow } from "src/app/shared/components/modal-window/ModalWindow";
import { IChannelOperator } from "src/app/channel/~store/models/ChannelOperator";
import SettingsItem from "src/app/setting/settings-main/settings-list/setting-item/SettingItem";
import i18n from "src/app/shared/localization/i18n";
import { OnChangeValue } from "react-select";
import { ChannelAuthQrModal } from "./channel-qr-modal/ChannelAuthQrModal"; 
import {fetchQrCode} from "src/app/channel/~store/actions/actions";
import { connect } from "react-redux";
import { IApplicationState } from "src/~store/models/ApplicationState";

type ReduxType = ReturnType<typeof mapStateToProps> & IChannelItemReduxProps & IChannelItemProps;
class ChannelItem extends React.Component<ReduxType, IChannelItemState> {
  public readonly state: IChannelItemState = {
    token: this.props.channel.token,
    name: this.props.channel.name,
    type: this.props.channel.type,
    enabled: this.props.channel.enabled,
    started: this.props.channel.started,
    nameTooltipMessage: "",
    tokenTooltipMessage: "",
    isChannelSettingOpen: false,
    isNameInvalid: false,
    isNameTooltipOpen: false,
    isTokenTooltipOpen: false,
    isModalVisible: false,
    isTokenInvalid: false,
    isNew: this.props.channel.channelId === 0,
    isQrModalOpen: false
  };

  public render() {
    const {
      token,
      name,
      type,
      enabled,
      started,
      isNameInvalid,
      isNameTooltipOpen,
      isTokenTooltipOpen,
      nameTooltipMessage,
      tokenTooltipMessage,
      isTokenInvalid,
      isNew
    } = this.state;

    const { allOperatorsShort } = this.props;
    const { channelId } = this.props.channel;
    const channelOperators = this.props.channel.operators;
    return (
      <React.Fragment>
        <div className="channel-item">
          <div className="channel-item-content">
            <span className="channel-item-id">
              #{this.props.channel.channelId}
            </span>
            <div className="channel-item__name-cell">
              <Input
                className="channel-item__input-name"
                id={"channelname" + this.props.channel.channelId}
                value={name}
                invalid={isNameInvalid}
                onChange={this._onNameChangeHandler}
                onBlur={this._onNameInputBlurHandler}
                onMouseEnter={this._onNameInputMouseEnterHandler}
                onMouseLeave={this._onNameInputMouseLeaveHandler}
                autoFocus={this.props.channel.channelId === 0}
              />
              <Tooltip
                placement="bottom-start"
                isOpen={isNameTooltipOpen}
                target={"channelname" + this.props.channel.channelId}
              >
                {nameTooltipMessage}
              </Tooltip>
            </div>
            <div>
              <Input
                type="select"
                className="channel-item__channel-type"
                disabled={this.props.channel.hasChats}
                defaultValue={channelTypeToString(type)}
                onChange={this._onTypeChangeHandler}
              >
                <option>{channelTypeToString(ChannelType.Telegram)}</option>
                <option>{channelTypeToString(ChannelType.Viber)}</option>
                <option>{channelTypeToString(ChannelType.Vk)}</option>
                <option>{channelTypeToString(ChannelType.Widget)}</option>
                <option>{channelTypeToString(ChannelType.Facebook)}</option>
                <option>{channelTypeToString(ChannelType.WeChat)}</option>
                <option>{channelTypeToString(ChannelType.Instagram)}</option>
                <option>
                  {channelTypeToString(ChannelType.UniformWidget)}
                </option>
                <option>{channelTypeToString(ChannelType.EdnaWhatsApp)}</option>
                <option>{channelTypeToString(ChannelType.WhatsApp)}</option>
                <option>{channelTypeToString(ChannelType.VoiceChannel)}</option>
                <option>{channelTypeToString(ChannelType.TelegramPrivate)}</option>
                <option>{channelTypeToString(ChannelType.SendPulse)}</option>
                <option>{channelTypeToString(ChannelType.Sms)}</option>
                <option>{channelTypeToString(ChannelType.ViberAlfa)}</option>
              </Input>
            </div>
            <div>
              <Input
                type="text"
                readOnly={this.props.channel.hasChats}
                className="channel-item__channel-token"
                id={"channeltoken" + this.props.channel.channelId}
                value={token}
                invalid={isTokenInvalid}
                onChange={this._onTokenChangeHandler}
                onBlur={this._onTokenInputBlurHandler}
                onMouseEnter={this._onTokenInputMouseEnterHandler}
                onMouseLeave={this._onTokenInputMouseLeaveHandler}
              ></Input>
              <Tooltip
                placement="bottom-start"
                isOpen={isTokenTooltipOpen}
                target={"channeltoken" + this.props.channel.channelId}
              >
                {tokenTooltipMessage}
              </Tooltip>
            </div>
            <div className="channel-item__enabled-cell">
              <Label
                tabIndex={0}
                check={enabled}
                onKeyUp={this._onEnabledKeyUpHandler}
              >
                <Input
                  tabIndex={-1}
                  type="checkbox"
                  name={"checkbox" + channelId}
                  checked={enabled}
                  onChange={this._onEnabledChangeHandler}
                />
                <span
                  className={
                    "channel-item__is-enabled " + (!started && "not-started")
                  }
                >
                  {""}
                </span>
              </Label>
            </div>
            <div className="channel-item__channel-actions">
            {!this.state.isNew &&
                this.props.channel.type === ChannelType.TelegramPrivate &&
                this.props.channel.enabled === true &&
                (
                  <Button
                     className="channel-item__btn-getQr"
                     disabled={this.props.channel.started === true}
                     onClick={() => this.setState({ isQrModalOpen: true })} >
                    <i className="material-icons">qr_code</i>
                  </Button>
                )}
              {!this.state.isNew &&
                this.props.channel.type === ChannelType.Widget && (
                  <Button
                    className="channel-item__btn-getScript"
                    onClick={this._getScript}
                  >
                    <i className="material-icons">code</i>
                  </Button>
                )}

              {!this.state.isNew && (
                <SettingsItem
                  setting={this.props.channel.setting}
                  onSettingSave={(setting) =>
                    this._onSaveChannelSettingHandler(setting.value)
                  }
                />
              )}
              <Button
                className="channel-item__btn-save"
                disabled={!this._channelItemIsValid()}
                onClick={() => this._onSaveChannelHandler()}
              >
                <i className="material-icons">save</i>
              </Button>
              {!this.state.isNew && (
                <Button
                  className="channel-item__btn-restart"
                  onClick={this._onRestartChannelHandler}
                >
                  <i className="material-icons">restart_alt</i>
                </Button>
              )}
              {!this.state.isNew && <Button
                className="channel-item__btn-remove"
                onClick={this._onDeleteChannelHandler}
              >
                <i className="material-icons">delete_forever</i>
              </Button>}
            </div>
          </div>
          <div className="channel-item__operators-row">
            <div className="channel-item__operators">
              <ChannelOperatorList
                channelOperators={channelOperators}
                allOperatorsShort={allOperatorsShort}
                channelId={this.props.channel.channelId ?? 0}
                onSaveChannelOperators={(channelOperators) =>
                  this._onSaveChannelHandler(channelOperators)
                }
              />
            </div>
          </div>
        </div>
        <ChannelAuthQrModal
          isOpen={this.state.isQrModalOpen}
          onClose={() => this.setState({ isQrModalOpen: false })}
          channelId={this.props.channel.channelId ?? 0}
          qrAuthData={this.props.qrAuthData}
          qrAuthIsLoading={this.props.qrAuthIsLoading}
          fetchQrCode={this.props.fetchQrCode}
        />
        <ModalWindow
          isOpen={this.state.isModalVisible}
          header={<div>{i18n.t("channels.copyScriptHeader")}</div>}
          body={<div>{i18n.t("channels.copyScriptBody")}</div>}
          footer={
            <Button
              onClick={() => {
                this.setState({ isModalVisible: false });
              }}
            >
              {i18n.t("common.close")}
            </Button>
          }
        ></ModalWindow>
      </React.Fragment>
    );
  }

  private _getScript = (): void => {
    const url: string = window.location.protocol + "//" + window.location.host;
    copy(getScript(this.props.channel.token, url));
    this.setState({ isModalVisible: true });
  };

  private _onTokenChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const token = event.currentTarget.value;
    const isTokenRequired =
      this.state.type !== ChannelType.Sms &&
      this.state.type !== ChannelType.ViberAlfa;
    let isTokenInvalid: boolean = false;
    let isTokenTooltipOpen: boolean = false;

    if (isTokenRequired && token.trim() === "") {
      isTokenInvalid = true;
      isTokenTooltipOpen = true;

      const tokenTooltipMessage: string = i18n.t(
        "channels.emptyTokenTooltipErrorMessage"
      );
      this.setState({ tokenTooltipMessage });
    }

    this.setState({ token, isTokenInvalid, isTokenTooltipOpen });
  };

  private _onNameChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const name = event.currentTarget.value;
    let isNameInvalid: boolean = false;
    let isNameTooltipOpen: boolean = false;

    if (name.trim() === "") {
      isNameInvalid = true;
      isNameTooltipOpen = true;

      const nameTooltipMessage: string = i18n.t(
        "channels.emptyNameTooltipErrorMessage"
      );
      this.setState({ nameTooltipMessage });
    }

    this.setState({ name, isNameInvalid, isNameTooltipOpen });
  };

  private _onNameInputMouseEnterHandler = (): void => {
    if (this.state.isNameInvalid) {
      const isNameTooltipOpen: boolean = true;
      this.setState({ isNameTooltipOpen });
    }
  };

  private _onNameInputMouseLeaveHandler = (): void => {
    const isNameTooltipOpen: boolean = false;
    this.setState({ isNameTooltipOpen });
    };

  private _onNameInputBlurHandler = (): void => {
      this.setState(prevState => ({
          name: prevState.name.trim()
      }));
  };

  private _onTokenInputMouseEnterHandler = (): void => {
    if (this.state.isTokenInvalid) {
      const isTokenTooltipOpen: boolean = true;
      this.setState({ isTokenTooltipOpen });
    }
  };

  private _onTokenInputMouseLeaveHandler = (): void => {
    const isTokenTooltipOpen: boolean = false;
    this.setState({ isTokenTooltipOpen });
    };

  private _onTokenInputBlurHandler = (): void => {
      this.setState(prevState => ({
          token: prevState.token.trim()
      }));
  };

  private _onTypeChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const opType = this._fromStringToType(event.currentTarget.value);
    const type: ChannelType = ChannelType[opType as keyof typeof ChannelType];
    const isTokenRequired = type !== ChannelType.Sms && type !== ChannelType.ViberAlfa;
    const isTokenInvalid = isTokenRequired && this.state.token.trim() === "";
    const isTokenTooltipOpen = isTokenInvalid;

    this.setState({ type, isTokenInvalid, isTokenTooltipOpen });
  };

  private _fromStringToType = (opType: string): any => {
    switch (opType) {
      case i18n.t("channels.telegram"):
        return "Telegram";
      case i18n.t("channels.viber"):
        return "Viber";
      case i18n.t("channels.vk"):
        return "Vk";
      case i18n.t("channels.widget"):
        return "Widget";
      case i18n.t("channels.facebook"):
        return "Facebook";
      case i18n.t("channels.weChat"):
        return "WeChat";
      case i18n.t("channels.instagram"):
        return "Instagram";
      case i18n.t("channels.uniformWidget"):
        return "UniformWidget";
      case i18n.t("channels.ednaWhatsApp"):
        return "EdnaWhatsApp";
      case i18n.t("channels.whatsApp"):
        return "WhatsApp";
      case i18n.t("channels.voiceChannel"):
        return "VoiceChannel";
      case i18n.t("channels.telegramPrivate"):
        return "TelegramPrivate";
      case i18n.t("channels.sendPulse"):
        return "SendPulse";
      case i18n.t("channels.sms"):
        return "Sms";
      case i18n.t("channels.viberAlfa"):
        return "ViberAlfa";
    }
  };

  private _onEnabledChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const enabled = event.currentTarget.checked;
    this.setState({ enabled });
  };

  private _onEnabledKeyUpHandler = (
    event: React.KeyboardEvent<HTMLLabelElement>
  ): void => {
    if (event.key === "Enter") {
      this.setState({ enabled: !this.state.enabled });
    }
  };

  private _channelItemIsValid = (): boolean => {
    const isTokenRequired = this.state.type !== ChannelType.Sms && this.state.type !== ChannelType.ViberAlfa;

    return !this.state.isNameInvalid &&
    !this.state.isTokenInvalid &&
    this.state.name !== "" &&
    (!isTokenRequired || this.state.token !== "");
  }

  private _onSaveChannelHandler = (
    channelOperators?: IChannelOperator[]
  ): void => {
    const isTokenRequired = this.state.type !== ChannelType.Sms && this.state.type !== ChannelType.ViberAlfa;

    if (
      this.state.isNameInvalid ||
      this.state.isTokenInvalid ||
      this.state.name === "" ||
      (isTokenRequired && this.state.token === "")
    ) {
      showErrorToastr(i18n.t("channels.invalidFieldsMessage"));
      return;
    }

    console.log(this.state.type);
    
    const channel: IChannel = {
      channelId: this.props.channel.channelId,
      name: this.state.name,
      enabled: this.state.enabled,
      started: false,
      modifiedOn: new Date(),
      type: this.state.type,
      setting: this.props.channel.setting,
      token: this.state.token,
      operators: [],
      hasChats: false,
    };

    if (this.props.channel.channelId !== undefined) {
      channel.operators = channelOperators ?? this.props.channel.operators;
    }
    this.props.onSaveChannel?.(channel);
  };

  private _onDeleteChannelHandler = (): void => {
    this.props.onDeleteChannel?.(this.props.channel);
  };

  private _onSaveChannelSettingHandler = (settings: string): void => {
    this.props.onSaveChannelSetting?.(this.props.channel, settings);
  };

  private _onRestartChannelHandler = (): void => {
    if (this.state.enabled) {
      this.props.onRestartChannel?.(this.props.channel);
    } else {
      showErrorToastr(i18n.t("channels.restartOnlyEnabledChannel"));
    }
  };
}

const mapStateToProps = (state: IApplicationState) => {
    return {
        qrAuthIsLoading: state.channelState.qrAuth.isLoading,
        qrAuthData: state.channelState.qrAuth.data
    };
};

const mapDispatchToProps = (dispatch: any): IChannelItemReduxProps => {
    return {
        fetchQrCode: (channelId: number) => dispatch(fetchQrCode(channelId))
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(ChannelItem);